// campaigns routes

const routes = [
  {
    path: "/campaigns",
    name: "CampaignsHome",
    component: () => import("@/views/campaigns/CampaignsHome.vue"),
    meta: { feature: "campaigns", requiresAuth: true, app: "campaigns" },
  },
  {
    path: "/campaigns/calendar",
    name: "CampaignsCalendar",
    component: () => import("@/views/campaigns/CampaignCalendarPage.vue"),
    meta: { feature: "campaigns", requiresAuth: true, app: "campaigns" },
  },
  {
    path: "/campaigns/calendar-weekly",
    name: "CampaignsWeeklyCalendar",
    component: () => import("@/views/campaigns/CampaignWeeklyCalendarPage.vue"),
    meta: { feature: "campaigns", requiresAuth: true, app: "campaigns" },
  },
];

export default routes;
